import React, {useEffect} from "react";

import cn from "classnames";
import stylesGlobal from "../../../../ListItem.module.scss";

const EmailSearch = ({query, activeLine, setLineLinks}) => {

    useEffect(() => {
        setLineLinks(links => ({...links,
            0: `/blacklists/${query}`,
            1: `/email-checker/${query}`
        }))
    }, [query]);

    return (
        <ul>
            <li className={cn(stylesGlobal.item, {[stylesGlobal.activeLine]: activeLine === 0})}>
                <svg className={stylesGlobal.loupe}>
                    <use href="/webpack/dist/sprite.svg#icon-search"></use>
                </svg>
                <a href={`/blacklists/${query}`} className={stylesGlobal.link}>{query} in <span
                    className={stylesGlobal.blue}>Block Lists</span></a>
            </li>
            <li className={cn(stylesGlobal.item, {[stylesGlobal.activeLine]: activeLine === 1})}>
                <svg className={stylesGlobal.loupe}>
                    <use href="/webpack/dist/sprite.svg#icon-search"></use>
                </svg>
                <a href={`/email-checker/${query}`} className={stylesGlobal.link}>{query} in <span
                    className={stylesGlobal.blue}>Email Checker</span></a>
            </li>
        </ul>
    )
};

export default EmailSearch;
